import React from "react";
import { TFuncKey } from "react-i18next";
import { Assignment, FitnessCenter, ListAlt, MenuBook } from "@material-ui/icons";
import { Area } from "types";
import { CataloguePath } from "routes/createContent/paths";
import { isContentOnly } from "utils/appMode";
import HealthForms from "routes/healthForms/HealthForms";
import { TemplateRoutes } from "routes/createContent/views/templates/TemplateRoutes";
import { ExerciseRoutes } from "routes/createContent/views/exercises/ExerciseRoutes";
import Lessons from "routes/createContent/views/lessons";
import ContentPage from "./ContentPage";

type ContentFeature = {
  area: string;
  label: TFuncKey;
  Icon: React.ComponentType;
  render: () => React.ReactNode;
};

export const contentFeatures: ContentFeature[] = [
  {
    area: Area.HealthForms,
    label: "views.health_forms",
    Icon: Assignment,
    render: () => <HealthForms />,
  },
  {
    area: CataloguePath.Templates,
    label: "views.treatment_templates",
    Icon: ListAlt,
    render: () => (
      <ContentPage>
        <TemplateRoutes />
      </ContentPage>
    ),
  },
  {
    area: CataloguePath.Exercises,
    label: "views.content_exercises",
    Icon: FitnessCenter,
    render: () => (
      <ContentPage>
        <ExerciseRoutes />
      </ContentPage>
    ),
  },
  {
    area: CataloguePath.Lessons,
    label: "views.content_lessons",
    Icon: MenuBook,
    render: () => (
      <ContentPage>
        <Lessons />
      </ContentPage>
    ),
  },
];

const contentAreas: string[] = contentFeatures.map(feature => feature.area);

export const navVisible = (area: string) =>
  isContentOnly ? contentAreas.includes(area) : !contentAreas.includes(area);
